// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_fXV","cls2":"AuthorsCard-cls2_T0F AuthorsCard-cls1_fXV"};